<template>
  <div id="links">
    <h3 class="titles" style="font-family: Arial; font-size: 40px">Start bioinformation</h3>
    <div style="border: 3px solid #CCCCCC; width: 400px"></div>
    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;padding-top: 80px"
          :src="url_bioinformatics">
        </el-image>
        <!--        <img src="../assets/cancersrt.png" alt="" width="100%" style="">-->
      </div>
      <div class="card-right">
        <p>
<!--          <span style="text-align: left; font-family: 'Arial';font-size: 36px;color: #005BAC;">-->
<!--              Peking University Bioinformatics: Learning methods-->
<!--          </span>-->
          <span class="title-span">Peking University Bioinformatics: Learning methods</span>
        </p>
        <p style="text-indent: 2em">
          <span style="text-align: center;font-family: 'Arial';">
            As a cutting-edge interdisciplinary course, this course is mainly aimed at senior undergraduates and first-year postgraduates majoring in bioinformatics, molecular biology, genetics, computer science, mathematics, statistics, physics and other related majors. Students should have basic knowledge of molecular biology and basic computational science knowledge and skills (including elementary probability theory, linear algebra, a programming language), and have an understanding of basic terminology in related fields (such as genes, expression, regulation, conditional probability, expectations, Bayes formula, etc.). Click <a href="https://www.bilibili.com/video/BV13t411G7oh/?spm_id_from=333.337.search-card.all.click&vd_source=18d740de3fbabf12f2b78d8eb8680b96" target="_blank">here</a> to visit.
          </span>
        </p>
      </div>
    </div>

    <h3 class="titles">Basic kit</h3>
    <div style="border: 3px solid #CCCCCC; width: 110px"></div>
    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_seurat">
        </el-image>
        <!--        <img src="../assets/cancersrt.png" alt="" width="100%" style="">-->
      </div>
      <div class="card-right">
        <p>
          <span class="title-span">Seurat</span>
        </p>
        <p style="text-indent: 2em">
          <span style="text-align: center;font-family: 'Arial';">
            Seurat is an R package designed for QC, analysis, and exploration of single-cell RNA-seq data. Seurat aims to enable users to identify and interpret sources of heterogeneity from single-cell transcriptomic measurements, and to integrate diverse types of single-cell data. Click <a href="https://satijalab.org/seurat/" target="_blank">here</a> to visit.
          </span>
        </p>
      </div>
    </div>
    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_scanpy">
        </el-image>
        <!--        <img src="../assets/cancersrt.png" alt="" width="100%" style="">-->
      </div>
      <div class="card-right">
        <p>
          <span class="title-span">Scanpy</span>
        </p>
        <p style="text-indent: 2em">
          <span style="text-align: center; font-family: 'Arial';">
            Scanpy is a scalable toolkit for analyzing single-cell gene expression data built jointly with anndata. It includes preprocessing, visualization, clustering, trajectory inference and differential expression testing. The Python-based implementation efficiently deals with datasets of more than one million cells. Click <a href="https://scanpy.readthedocs.io/en/stable/" target="_blank">here</a> to visit.
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Links',

  data () {
    return {
      url_bioinformatics: require('../assets/bioinformatics.png'),
      url_seurat: require('../assets/seuart.png'),
      url_scanpy: require('../assets/scanpy.png')
    }
  }
}
</script>

<style scoped>
.titles{
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
}
.card{
  display: flex;
  justify-content: space-evenly;
  margin: 50px 0 50px 0;
}
.card-left{
  width: 50%;
}
.card-right{
  flex: 1;
  margin-left: 5%;
}
p{
  font-size: 20px;
  line-height: 30px;
  text-align: justify;
}
.title-span{
  font-size: 36px;
  font-family: "Arial";
  color: #005BAC;
}
</style>



// WEBPACK FOOTER //
// src/components2/Links.vue